<template>
  <div style="position: relative; padding: 0px 0 30px">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium' || isCoachlab"
      style="border-radius: 5px;"
    ></v-premium-plan-popup>
    <v-container>
      <div>
        <h3 class="headline">{{$t('All Wholesale')}}</h3>

        <v-layout row>
          <v-flex>{{$t('Turn On/Off Wholesale Activity')}}</v-flex>
          <v-flex class="text-xs-right">
            <label class="toggle-switch small" style="margin-top: 10px;vertical-align: bottom;">
              <input type="checkbox" :checked="wholesaleStatus" @change="toggleWholesaleStatus()" />
              <span class="toggle-slider lever round"></span>
            </label>
          </v-flex>
        </v-layout>
        <label for class="caption">
          <i class="fas fa-exclamation-circle"></i>
          {{$t('Turn on Wholesale Activity to mix all products in your Shop Service and offer the Wholesale Price')}}
        </label>
      </div>
      <v-divider class="mt-3 mb-3"></v-divider>
      <div>
        <v-layout row wrap>
          <v-flex xs9>
            <h3 class="headline">{{$t('Manage Wholesale Activity')}}</h3>
          </v-flex>
          <v-flex xs3 class="text-xs-right">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditWholesale && $store.getters.getPackage == 'premium' && !isCoachlab"
              @click="isEditWholesale = true"
            >
              <i class="fa fa-pencil-alt middle"></i>
            </v-btn>
          </v-flex>
        </v-layout>

        <template v-if="loading">
          <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
        </template>
        <template v-else-if="isEditWholesale">
          <product-bundle v-model="wholesale" @deleteBundle="deleteBundle"></product-bundle>

          <div class="text-xs-center pt-3 pb-3">
            <v-btn outline color="grey" @click="cancelEditWholesale">{{$t('cancel')}}</v-btn>
            <v-btn depressed color="primary" @click="saveEditWholesale">{{$t('Save')}}</v-btn>
          </div>
          <div class="row">
            <div class="col s12"></div>
            <div class="col s12 text-xs-center" style="padding-top: 15px; padding-bottom: 15px;"></div>
          </div>
        </template>
        <template v-else>
          <div class="text-xs-center" v-if="wholesale.length == 0">{{$t('No wholesale')}}</div>
          <div v-else>
            <v-data-table :items="wholesale" class="elevation-1" hide-actions :headers="headers">
              <template v-slot:items="props">
                <td class="text-xs-center">{{$t('Price range')}} {{props.index + 1}}</td>
                <td class="text-xs-center">{{ props.item.minquantity }}</td>
                <td class="text-xs-center">{{ props.item.maxquantity }}</td>
                <td class="text-xs-center">{{ props.item.price }}</td>
              </template>
            </v-data-table>
          </div>
        </template>
      </div>
    </v-container>
  </div>
</template>

<script>
import ProductBundle from './ProductBundle'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data: function() {
    return {
      headers: [
        { text: this.$t('Price range'), sortable: false, align: 'center' },
        { text: this.$t('Minimum Price Range'), sortable: false, align: 'center' },
        { text: this.$t('Maximum Price Range'), sortable: false, align: 'center' },
        { text: this.$t('Price per unit'), sortable: false, align: 'center' }
      ],
      loading: true,
      wholesaleStatus: false,
      isEditWholesale: false,
      wholesale: [],
      deleteWholesaleList: [],
      wholesaleProcessCount: 0,
      loadingWholesale: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCoachlab'])
  },
  components: {
    ProductBundle,
    ScaleLoader
  },
  mounted: function() {
    var vm = this
    vm.loading = true
    vm.getWholesaleStatus().then(function() {
      vm.getWholesale().then(function() {
        vm.cached_wholesale = JSON.stringify(vm.wholesale)
        vm.loading = false
      })
    })
  },
  methods: {
    getWholesale: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        api.getWholesale({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response) {
            vm.wholesale = response.wholesalelist
          }
          resolve()
        })
      })
    },
    getWholesaleStatus: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getWholesaleStatus({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          vm.wholesaleStatus = response.data.wholesale_status === true
          resolve()
        })
      })
    },
    toggleWholesaleStatus: function() {
      var vm = this
      if (vm.$store.getters.getPackage !== 'premium' || vm.isCoachlab) {
        return false
      }
      vm.$store.dispatch('loading')
      api.saveWholesaleStatus(
        { pageid: vm.selectedBot.pageid, wholesale_status: !vm.wholesaleStatus },
        function(error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            console.error(error)
            return
          }
          vm.$store.dispatch('loading')
        }
      )
    },
    cancelEditWholesale: function() {
      var vm = this
      vm.isEditWholesale = false
      vm.wholesale = JSON.parse(vm.cached_wholesale)
    },
    saveEditWholesale: function() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.$store.getters.getPackage !== 'premium' || vm.isCoachlab) {
          return false
        }
        vm.$store.dispatch('loading')
        vm.saveWholesale().then(function() {
          vm.isEditWholesale = false
          vm.deleteWholesaleList = []
          vm.cached_wholesale = JSON.stringify(vm.wholesale)
          vm.$store.dispatch('loading')
        })
      })
    },
    saveWholesale: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.wholesaleProcessCount = vm.wholesale.length + vm.deleteWholesaleList.length

        if (vm.wholesale) {
          vm.wholesale.map(function(bundle, index) {
            var data = null
            if (bundle.id) {
              // api.saveWholesale({wholesaleid: bundle.id})
              data = bundle
              data.wholesaleid = bundle.id
              api.editWholesale(data, function(error, response) {
                if (error) {
                  console.error(error)
                }
                vm.wholesaleProcessCount--
              })
            } else {
              data = bundle
              data.pageid = vm.selectedBot.pageid
              api.saveWholesale(data, function(error, response) {
                if (error) {
                  console.error(error)
                }
                if (response.wholesaleid) {
                  vm.wholesale[index].id = response.wholesaleid
                }
                vm.wholesaleProcessCount--
              })
            }
          })
        }

        if (vm.deleteWholesaleList) {
          vm.deleteWholesaleList.map(function(bundle, index) {
            api.deleteWholesale({ wholesaleid: bundle }, function(error, response) {
              if (error) {
                console.error(error)
              }
              vm.wholesaleProcessCount--
            })
          })
        }

        vm.loadingWholesale = setInterval(function() {
          if (vm.wholesaleProcessCount === 0) {
            if (vm.loadingWholesale) {
              clearInterval(vm.loadingWholesale)
            }
            resolve()
          }
        }, 1000)
      })
    },
    deleteBundle: function(id) {
      this.deleteWholesaleList.push(id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Wholesale.vue